import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    List,
    ListItem,
    ListItemText,
    Typography,
    Divider,
    Button,
} from '@mui/material';

import moment from 'moment';
import momentz from 'moment-timezone'

const OrderDetailsDialog = ({ open, handleClose, orderDetails ,type }) => {
    // console.log({orderDetails , type})
    const { userTimeSlots, sessionSlots, meetingLink, driveLink , userTimezone } = orderDetails;
    console.log({userTimezoneval:userTimezone})
    const convertUtcTimeToLocal = (timeString) =>{
        // Split hours and minutes from the input string
        const [hours, minutes] = timeString.split(":").map(Number);
        
        // Create a Date object with UTC time based on today's date
        const utcDate = new Date();
        utcDate.setUTCHours(hours, minutes, 0, 0); // Set hours, minutes, seconds, milliseconds in UTC
        
        // Convert to local time string
        const localTimeString = utcDate.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        });
      
        return localTimeString;
      }

      const getDayName = (utcDay) => {
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" , "Sunday"];
        return dayNames[utcDay];
      }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Order Details</DialogTitle>
            <DialogContent>
                {/* Meeting and Drive Links */}
                <Typography variant="h6">Links:</Typography>
                <List>
                    <ListItem>
                        {/* <ListItemText primary="Meeting Link" secondary={meetingLink || 'N/A'} /> */}
                        <a href={meetingLink} target='_blank'>{meetingLink}</a>
                    </ListItem>
                    {/* <ListItem>
                        <ListItemText primary="Drive Link" secondary={driveLink || 'N/A'} />
                    </ListItem> */}
                </List>

                <Divider />

                {/* User Time Slots */}
                {type == 'Live Course' && 
                <><Typography variant="h6" sx={{ mt: 2 }}>
                    Client Availability:
                </Typography>
                <List>
                    {userTimeSlots?.length ? (
                        userTimeSlots.map((slot, index) => (
                            <ListItem key={index}>
                                {/* <ListItemText
                                    primary={`Day: ${slot.day}`}
                                    secondary={`From: ${slot.from} to: ${slot.to} (UTC From: ${slot.utcFrom}, UTC To: ${slot.utcTo})`}
                                /> */}
                                <div style = {{display: "flex" , justifyContent : "space-between" ,gap: "20px"}}>
                                    <p><strong>From:</strong> {getDayName(+slot?.utcFromDay) + "," +  convertUtcTimeToLocal(slot.utcFrom)}</p>
                                    <p><strong>To:</strong> {getDayName(+slot?.utcToDay) + "," +  convertUtcTimeToLocal(slot.utcTo)}</p>
                                </div>
                            </ListItem>
                        ))
                    ) : (
                        <ListItem>
                            <ListItemText primary="Data Not Available" />
                        </ListItem>
                    )}
                </List>

                <Divider />

                {/* Session Slots */}
                <Typography variant="h6" sx={{ mt: 2 }}>
                    Session Slots:
                </Typography>
                <List>
                    {sessionSlots?.length ? (
                        sessionSlots.map((session, index) => (
                            <ListItem key={index}>
                                {/* <ListItemText
                                    primary={`Session ${session.sessionNumber}`}
                                    secondary={`Date: ${new Date(session.utcDate).toLocaleDateString()} 
                                    From: ${session.utcFrom} To: ${session.utcTo} 
                                    Status: ${session.slotStatus}`}
                                /> */}
                                <div key={index} style = {{display: "flex" , padding: "15px" , flexDirection: "column" ,  gap: '5px' , backgroundColor: "#ffffff"}}>
                                <div style = {{display: "flex" , justifyContent : "space-between" ,gap: "20px"}}>
                                    <p><b>Class Id:</b> {session?.sessionNumber}</p>
                                    <p><b>Status:</b> {session?.slotStatus}</p>
                                    </div>
                                    <div style = {{display: "flex" , justifyContent : "space-between" ,gap: "20px"}}>
                                    <p><b>Date & Time:</b> 
                                    {momentz.tz(session?.utcFrom, "YYYY-MM-DDTHH:mm:ss", userTimezone).local().format("lll")}
                                    </p>
                                    <p><b>Duration:</b> {session?.sessionDuration ? session?.sessionDuration + " min" : 'NA'}</p>
                                    </div>
                                    </div>
                            </ListItem>
                        ))
                    ) : (
                        <ListItem>
                            <ListItemText primary="No Session Slots available." />
                        </ListItem>
                    )}
                </List>
                </>
                }
                
                <Divider />

                <Button onClick={handleClose} variant="contained" color="primary" sx={{ mt: 2 }}>
                    Close
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default OrderDetailsDialog;
